module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad2/img_voice01-856cf5582eb97b711cf32e56100865fa.jpg";